import ORGStrawberryImage from './products/Solero-JPG-Image-4-ct-Organic-Strawberry.jpg'
import ORGStrawberryIngredientsImage from './products/nutrition-facts/organic-strawberry-nutrition.png'

import ORGPinaColadaImage from './products/Solero-JPG-Image-4-ct-Organic-Pina-Colada.jpg'
import ORGPinaColadaIngredientsImage from './products/nutrition-facts/organic-pina-colada.png'

import ORGCoconutImage from './products/Solero-JPG-Image-4-ct-Organic-Coconut.jpg'
import ORGCoconutIngredientsImage from './products/nutrition-facts/organic-coconut.png'

import ORGStrawberryColadaImage from './products/Solero-JPG-Image-4-ct-Organic-Strawberry-Colada.jpg'
import ORGStrawberryColadaIngredientsImage from './products/nutrition-facts/organic-strawberry-colada.png'

import ORGMangoImage from './products/Solero-JPG-Image-4-ct-Organic-Mango.jpg'
import ORGMangoIngredientsImage from './products/nutrition-facts/organic-mango-nutrition.png'

import StrawberryImage from './products/Solero-JPG-Image-6-ct-Natural-Strawberry.jpg'
import StrawberryIngredientsImage from './products/nutrition-facts/natural-strawberry-nutrition.png'

import CoconutImage from './products/Solero-JPG-Image-6-ct-Natural-Coconut-w-Cream.jpg'
import CoconutIngredientsImage from './products/nutrition-facts/natural-coconut.png'

import StrawberryColadaImage from './products/Solero-JPG-Image-6-ct-Natural-Strawberry-Colada.jpg'
import StrawberryColadaIngredientsImage from './products/nutrition-facts/natural-strawberry-colada.png'

import PopsLemonLimeStrawberryImage from './products/Solero-JPG-Image-10-ct-Pops-Strawberry-and-Lemon-Lime.jpg'
import PopsLemonLimeIngredientsImage from './products/nutrition-facts/pops-strawberry-lemon-lime.png'

import PopsBananaCoconutImage from './products/Solero-JPG-Image-10-ct-Cream-Pops-Coconut-and-Banana-Cinn.jpg'
import PopsCoconutIngredientsImage from './products/nutrition-facts/banana-cinnamon-nutrition.png'

// Indulgent Cream Bars
import IndulgentChocolateImage from './products/Solero-JPG-Image-4ct-CREAM-Chocolate-Image.jpg'
import IndulgentChocolateIngredientsImage from './products/nutrition-facts/chocolate-cream-nutrition.jpg'

import IndulgentCoconutImage from './products/Solero-JPG-Image-4ct-CREAM-Coconut-Image.jpg'
import IndulgentCoconutIngredientsImage from './products/nutrition-facts/coconut-cream-nutrition.jpg'

import IndulgentMintImage from './products/Solero-JPG-Image-4ct-CREAM-Mint-w-Chocolate-Image.jpg'
import IndulgentMintIngredientsImage from './products/nutrition-facts/mint-cream-nutrition.jpg'

import IndulgentOrangeImage from './products/Solero-JPG-Image-4ct-CREAM-Orange-Image.jpg'
import IndulgentOrangeIngredientsImage from './products/nutrition-facts/orange-cream-nutrition.jpg'

import IndulgentVanillaImage from './products/Solero-JPG-Image-4ct-CREAM-Vanilla-Image.jpg'
import IndulgentVanillaIngredientsImage from './products/nutrition-facts/vanilla-cream-nutrition.jpg'

// Added after this version of sourcecode
import OrganicWatermelonImage from './products/Solero-JPG-Image-4-ct-Organic-Watermelon.jpg'
import OrganicWatermelonIngredientsImage from './products/nutrition-facts/watermelon-nutritionals.png'

import StrawberryChocolateImage from './products/Solero-JPG-Image-10-ct-Cream-Pops-Chocolate-and-Strawberry.jpg'
import StrawberryChocolateIngredients from './products/nutrition-facts/pops-strawberry-chocolate.png'

import CherryLimeImage from './products/Solero-JPG-Image-10-ct-Pops-Cherry-and-Lime.jpg'
import CherryLimeIngredients from './products/nutrition-facts/pops-cherry-lime-nutrition.png'

import RaspberryTanImage from './products/Solero-JPG-Image-10-ct-Pops-Raspberry-and-Tangerine.jpg'
import RaspberryTanIngredients from './products/nutrition-facts/pops-raspberry-tangerine-nutrition.png'

import GrapeImage from './products/Solero-JPG-Image-10-ct-Pops-NSA-Grape-and-Cherry.jpg'
import GrapeIngredientsImage from './products/nutrition-facts/pops-grape-cherry-nutrition.png'

let ProductsData = {
  products: {
    cream: [
      {
        description:
          'Unsweetened chocolate and cocoa from the United States is mixed with skim milk, real cream, sugar, and a hint of vanilla extract. Available in a four-pack with 110 calories per bar.',
        image: IndulgentChocolateImage,
        imageLarge: IndulgentChocolateImage,
        ingredients: [
          'Skim Milk, Cream, Sugar, Unsweetened Chocolate Processed with Alkali, Cocoa Processed with Alkali, Guar Gum, Carob Gum, Vanilla Extract.'
        ],
        Allergens: ['Contains Milk.'],
        ingredientsImage: IndulgentChocolateIngredientsImage,
        title: 'Indulgent Cream Chocolate'
      },
      {
        description:
          'Coconuts from Sri Lanka and the Philippines are pureed and carefully blended with skim milk, real cream, sugar, and a hint of vanilla. Available in a four-pack with 100 calories per bar.',
        image: IndulgentCoconutImage,
        imageLarge: IndulgentCoconutImage,
        ingredients: [
          'Skim Milk, Cream, Sugar, Coconut Cream, Shredded Coconut, Carob Gum, Guar Gum, Vanilla Extract, Lemon Juice Concentrate.'
        ],
        Allergens: ['Contains Coconut, Milk.'],
        ingredientsImage: IndulgentCoconutIngredientsImage,
        title: 'Indulgent Cream Coconut'
      },
      {
        description:
          'Chocolate bits and pieces from the United States are mixed with skim milk, real cream, sugar, and a hint of peppermint. Available in a four-pack with 110 calories per bar.',
        image: IndulgentMintImage,
        imageLarge: IndulgentMintImage,
        ingredients: [
          'Skim Milk, Cream, Sugar, Chocolaty Chips (Sugar, Palm Kernel Oil, Whole Milk Powder, Cocoa Powder, Lactose, Soy Lecithin, Natural Flavor, Salt), Peppermint Extract, Spirulina Extract for Color, Guar Gum, Carob Gum, Vanilla Extract, Anise Oil, Beta Carotene for Color.'
        ],
        Allergens: ['Contains Milk, Soy.'],
        ingredientsImage: IndulgentMintIngredientsImage,
        title: 'Indulgent Cream Mint with Chocolate'
      },
      {
        description:
          'Juice from oranges sourced in the United States are mixed with skim milk, real cream and a hint of vanilla extract. Available in a four-pack with 100 calories per bar.',
        image: IndulgentOrangeImage,
        imageLarge: IndulgentOrangeImage,
        ingredients: [
          'Skim Milk, Cream, Sugar, Orange Juice Concentrate, Oil of Orange, Guar Gum, Carob Gum, Xanthan Gum, Vanilla Extract, Annatto Extract for Color.'
        ],
        Allergens: ['Contains Milk.'],
        ingredientsImage: IndulgentOrangeIngredientsImage,
        title: 'Indulgent Cream Orange'
      },
      {
        description:
          'Ground vanilla beans are blended with skim milk, real cream, sugar, and a hint of vanilla extract. Available in a four-pack with 100 calories per bar.',
        image: IndulgentVanillaImage,
        imageLarge: IndulgentVanillaImage,
        ingredients: ['Skim Milk, Cream, Sugar, Vanilla Extract, Guar Gum, Carob Gum, Ground Vanilla Beans.'],
        Allergens: ['Contains Milk.'],
        ingredientsImage: IndulgentVanillaIngredientsImage,
        title: 'Indulgent Cream Vanilla'
      }
    ],
    organic: [
      {
        description:
          'Organic coconuts from Sri Lanka and the Philippines pureed into a fine cream and mixed with organic cane sugar and water. Available in a four-count pack with 110 calories per bar.',
        image: ORGCoconutImage,
        imageLarge: ORGCoconutImage,
        ingredients: [
          'WATER, ORGANIC COCONUT, ORGANIC CANE SUGAR, ORGANIC GUAR GUM, ORGANIC CAROB GUM, ORGANIC GUM ACACIA'
        ],
        Allergens: ['CONTAINS COCONUT'],
        ingredientsImage: ORGCoconutIngredientsImage,
        title: 'Organic Coconut'
      },

      {
        description:
          'Pureed, organic mangos from Colombia combined with organic cane sugar, water and pieces of real, organic mangos from Peru. Available in a four-count pack with 80 calories per bar.',
        image: ORGMangoImage,
        imageLarge: ORGMangoImage,
        ingredients: ['WATER, ORGANIC MANGO, ORGANIC CANE SUGAR, ORGANIC GUAR GUM, ORGANIC CAROB GUM'],
        ingredientsImage: ORGMangoIngredientsImage,
        title: 'Organic Mango'
      },
      {
        description:
          'Organic coconuts from Sri Lanka and the Philippines pureed into a fine cream and mixed with organic cane sugar, water and pieces of real, organic Pineapples from Costa Rica. Available in a four-count pack with 120 calories per bar.',
        image: ORGPinaColadaImage,
        imageLarge: ORGPinaColadaImage,
        ingredients: [
          'WATER, ORGANIC CANE SUGAR, ORGANIC PINEAPPLE, ORGANIC COCONUT, ORGANIC GUAR GUM, ORGANIC CAROB GUM'
        ],
        Allergens: ['CONTAINS COCONUT'],
        ingredientsImage: ORGPinaColadaIngredientsImage,
        title: 'Organic Pina Colada'
      },
      {
        description:
          'Organic Watermelon from the US mixed with a touch of organic cane sugar, water and a hint of lemon juice to sweeten to perfection.  Available in a four-count pack with 70 calories per bar.',
        image: OrganicWatermelonImage,
        imageLarge: OrganicWatermelonImage,
        ingredients: [
          'WATER, ORGANIC WATERMELON, ORGANIC CANE SUGAR, ORGANIC LEMON JUICE CONCENTRATE, ORGANIC GUAR GUM, ORGANIC CAROB BEAN GUM, COLOR'
        ],
        ingredientsImage: OrganicWatermelonIngredientsImage,
        title: 'Organic Watermelon'
      },
      {
        description:
          'Organic, pureed strawberries from California mixed with organic cane sugar, water, pieces of real, organic strawberries and a dash of lemon juice. Available in a four-count pack with 80 calories per bar.',
        image: ORGStrawberryImage,
        imageLarge: ORGStrawberryImage,
        ingredients: [
          'WATER, ORGANIC STRAWBERRIES, ORGANIC CANE SUGAR, ORGANIC GUAR GUM, ORGANIC CAROB GUM, ORGANIC LEMON JUICE'
        ],
        ingredientsImage: ORGStrawberryIngredientsImage,
        title: 'Organic Fresh Strawberry'
      },
      {
        description:
          'Organic coconuts from Sri Lanka and the Philippines pureed into a fine cream with organic sugar cane and water, and then mixed with organic, pureed strawberries from California. Combines two Solero® favorites: Organic Fresh Strawberry and Organic Piña Colada. Available in a four-count pack with 100 calories per bar.',
        image: ORGStrawberryColadaImage,
        imageLarge: ORGStrawberryColadaImage,
        ingredients: [
          'WATER, ORGANIC CANE SUGAR, ORGANIC STRAWBERRIES, ORGANIC PINEAPPLE, ORGANIC COCONUT, ORGANIC GUAR GUM, ORGANIC CAROB GUM, ORGANIC LEMON JUICE'
        ],
        Allergens: ['CONTAINS COCONUT'],
        ingredientsImage: ORGStrawberryColadaIngredientsImage,
        title: 'Organic Strawberry Colada'
      }
    ],
    natural: [
      {
        description:
          'Coconuts from Sri Lanka and the Philippines pureed into a fine cream and mixed with sugar, water, real cream and hint of vanilla. Available in a six-count pack with 100 calories per bar.',
        image: CoconutImage,
        imageLarge: CoconutImage,
        ingredients: [
          'SKIM MILK, SUGAR, CREAM, COCONUT, LEMON JUICE CONCENTRATE, VANILLA EXTRACT, CAROB GUM, GUAR GUM'
        ],
        Allergens: ['CONTAINS: COCONUT, MILK'],
        ingredientsImage: CoconutIngredientsImage,
        title: 'Natural Coconut with Cream'
      },
      {
        description:
          'Pureed strawberries from California mixed with sugar, water, pieces of real strawberries and a dash of lemon juice. Available in a six-count pack with 70 calories per bar.',
        image: StrawberryImage,
        imageLarge: StrawberryImage,
        ingredients: ['STRAWBERRIES, WATER, SUGAR, LEMON JUICE CONCENTRATE, CAROB GUM, GUAR GUM'],
        ingredientsImage: StrawberryIngredientsImage,
        title: 'Natural Strawberry'
      },
      {
        description:
          'Coconuts pureed into a fine cream with pineapple juice and mixed with sugar, water, and pieces of real pineapple. Available in a six-count pack with 90 calories per bar.',
        image: StrawberryColadaImage,
        imageLarge: StrawberryColadaImage,
        ingredients: [
          'Water, Strawberries, Sugar, Coconut Cream, Pineapple, Pineapple Juice, Lemon Juice Concentrate, Carob Gum, Guar Gum, Citric Acid.'
        ],
        Allergens: ['CONTAINS COCONUT'],
        ingredientsImage: StrawberryColadaIngredientsImage,
        title: 'Natural Strawberry Colada'
      }
    ],
    pops: [
      {
        description:
          'Indulgent Cream Coconut: Shredded Coconuts from Sri Lanka and the Philippines pureed and mixed with sugar, water, real cream and a hint of vanilla. 80 calories per pop.<br><br>Indulgent Cream Banana Cinnamon: Pureed bananas sourced from sunny El Salvador blended with sugar, water, real cream and a dash of cinnamon. 70 calories per pop.',
        image: PopsBananaCoconutImage,
        imageLarge: PopsBananaCoconutImage,
        ingredients: [
          'Coconut: SKIM MILK, SUGAR, CREAM, COCONUT, LEMON JUICE CONCENTRATE, VANILLA EXTRACT, CAROB GUM, GUAR GUM.<br><br>Banana Cinnamon: SKIM MILK, BANANA, SUGAR, CREAM, CAROB GUM, CINNAMON, GUAR GUM, COCONUT'
        ],
        Allergens: ['CONTAINS COCONUT, MILK'],
        ingredientsImage: PopsCoconutIngredientsImage,
        title: 'Indulgent Cream Coconut and Banana Cinnamon Pops'
      },
      {
        description:
          ' Strawberry: Strawberries sourced from California blended with real cream, sugar and water. 70 calories per pop.<br><br>Chocolate: Chocolate and cocoa from the United States mixed with real cream and sugar and a hint of vanilla. 90 calories per pop.',
        image: StrawberryChocolateImage,
        imageLarge: StrawberryChocolateImage,
        ingredients: [
          'STRAWBERRY: Skim Milk, Strawberries, Sugar, Cream, Water, Guar Gum, Carob Gum.<br><br>CHOCOLATE: Skim Milk, Cream, Sugar, Chocolate Processed with Alkali, Cocoa Processed with Alkali, Vanilla Extract, Guar Gum, Carob Gum.'
        ],
        Allergens: ['CONTAINS: MILK'],
        ingredientsImage: StrawberryChocolateIngredients,
        title: 'Indulgent Cream Strawberry and Chocolate Pops'
      },
      {
        description:
          'Strawberry: Strawberries sourced from California blended with sugar and water. 45 calories per pop.<br><br>Lemon Lime: Juice from limes sourced from the United States mixed with sugar and water and blended with oils from the lime peels to enhance the natural citrus taste. 50 calories per pop.',
        image: PopsLemonLimeStrawberryImage,
        imageLarge: PopsLemonLimeStrawberryImage,
        ingredients: [
          'Strawberry: STRAWBERRIES, WATER, SUGAR, LEMON JUICE CONCENTRATE, CAROB GUM, GUAR GUM<br><br>LEMON LIME: WATER, SUGAR, LEMON AND LIME JUICE CONCENTRATE, CAROB GUM, CRUSHED LIME, LEMON AND LIME OIL.'
        ],

        ingredientsImage: PopsLemonLimeIngredientsImage,
        title: 'Strawberry and Lemon Lime Pops'
      },
      {
        description:
          'Cherry: Cherry puree from the Pacific Northwest mixed with sugar, water and a hint of lemon juice concentrate. 45 calories per pop.<br><br>Cherry: Cherry puree from the Pacific Northwest mixed with sugar, water and a hint of lemon juice concentrate. 45 calories per pop.',
        image: CherryLimeImage,
        imageLarge: CherryLimeImage,
        ingredients: [
          'CHERRY: Water, Cherry Puree Concentrate, Sugar, Lemon Juice Concentrate, Carob Gum, Guar Gum.<br><br>LIME: Water, Sugar, Lime Juice Concentrate, Carob Gum, Lime Pulp, Lime Oil.'
        ],
        ingredientsImage: CherryLimeIngredients,
        title: 'Cherry and Lime Pops'
      },
      {
        description:
          'Raspberry: Raspberry puree mixed with sugar, water and a hint of lemon juice concentrate. 40 calories per pop.<br><br>Tangerine: Tangerine puree and Tangerine juice blended together with sugar and water and a splash of lemon juice for perfection. 40 calories per pop.',
        image: RaspberryTanImage,
        imageLarge: RaspberryTanImage,
        ingredients: [
          'RASPBERRY: Water, Raspberries, Sugar, Lemon Juice Concentrate, Carob Gum, Guar Gum.<br><br>Tangerine: Water, Sugar, Tangerine Puree, Tangerine Juice Concentrate, Lemon Juice Concentrate, Carob Gum, Guar Gum.'
        ],
        ingredientsImage: RaspberryTanIngredients,
        title: 'Raspberry and Tangerine Pops'
      },
      {
        description:
          'Grape: Grape juice sourced from the Pacific Northwest combined with lemon juice and monk fruit for a delicious taste with no sugar added. 40 calories per pop.<br><br>Cherry: Cherry juice from the Pacific Northwest combined with lemon juice and monk fruit for a delicious taste with no sugar added. 40 calories per pop.',
        image: GrapeImage,
        imageLarge: GrapeImage,
        ingredients: [
          'GRAPE: Grape Juice from Concentrate, Maltitol, Maltodextrin, Lemon Juice Concentrate, Monk Fruit, Carob Gum, Guar Gum.<br><br>CHERRY: Cherry Juice from Concentrate, Maltodextrin, Maltitol, Lemon Juice Concentrate, Carob Gum, Guar Gum, Monk Fruit.'
        ],
        ingredientsImage: GrapeIngredientsImage,
        title: 'No Sugar Added Grape and Cherry Pops'
      }
    ]
  },
  categoriesList: [
    'All Products',
    'Indulgent Cream Bars',
    'Organic Crushed Fruit Bars',
    'Natural Crushed Fruit Bars',
    'Natural Crushed Fruit Pops'
  ]
}

export default ProductsData



// WEBPACK FOOTER //
// ./src/views/ourProducts/ProductsData.js